import { Box, Grid, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import * as React from "react";
import "./images/arrow-up-min.png";

export function MakeItMonthlyButtons(props: { isRegular: boolean; setIsRegular: (arg: boolean) => void }) {
  const handleButtonChange = (_: React.MouseEvent<HTMLElement>, newValue: boolean) => {
    props.setIsRegular(newValue);
  };

  return (
    <>
      <ToggleButtonGroup
        fullWidth
        value={props.isRegular}
        exclusive
        onChange={handleButtonChange}
        aria-label="Make It Monthly Donation Buttons"
      >
        <ToggleButton value={false} aria-label="one-off donation" color="secondary">
          <Typography variant="subtitle1">Chip In Once</Typography>
        </ToggleButton>
        <ToggleButton value={true} aria-label="monthly donation" color="secondary">
          <Typography variant="subtitle1">Chip In Monthly</Typography>
        </ToggleButton>
      </ToggleButtonGroup>

      <Grid container justifyContent="flex-end" width="75%" marginTop="1rem">
        <Box
          component="img"
          sx={{
            width: 18,
          }}
          alt="arrow pointing up"
          src="/arrow-up-min.png"
        />
      </Grid>

      <Typography align="center" variant="body1">
        Make a bigger impact by repeating your donation monthly
      </Typography>
    </>
  );
}
